export const MIN_PROGRESS = 5;
